import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import MaterialIcon from './MaterialIcon';

const Navbar = ({ setIsModalOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToProducts = () => {
    if (location.pathname !== '/') {
      navigate('/');
      // 等待页面加载完成后再滚动
      setTimeout(() => {
        document.getElementById('products-section')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById('products-section')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 bg-[#2C3E50] z-50">
        <div className="container-wide">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <Link to="/" className="text-xl font-bold text-[#F1F600]">
              BetterUs
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={scrollToTop}
                className="text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-all duration-300 relative group"
              >
                <span>首页</span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#F1F600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </button>
              <button
                onClick={scrollToProducts}
                className="text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-all duration-300 relative group"
              >
                <span>产品</span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#F1F600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </button>
              <Link to="/blog" onClick={(e) => {
                e.preventDefault();
                window.location.href = "https://www.betterus.cc/blog";
              }}
                className="text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-all duration-300 relative group">
                <span>资讯</span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#F1F600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </Link>
              {/* <Link to="/coaches" className="text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-all duration-300 relative group">
                <span>教练风采</span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#F1F600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </Link> */}
              <Link to="/about" className="text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-all duration-300 relative group">
                <span>关于我们</span>
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-[#F1F600] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </Link>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="px-6 py-2 bg-[#2C3E50] text-white rounded-lg font-medium hover:bg-[#2C3E50]/90 transition-all duration-300"
                >
                  联系平台
                </button>
                <a
                  href="https://h5.betterus.cc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2 bg-[#F1F600] text-[#2C3E50] rounded-lg font-medium hover:bg-[#F1F600]/90 transition-all duration-300"
                  onClick={(e) => {
                    e.preventDefault();
                    const userAgent = navigator.userAgent.toLowerCase();
                    const isIOS = /iphone|ipad|ipod/.test(userAgent);
                    const isMac = /macintosh|mac os x/.test(userAgent) && !/mobile/.test(userAgent);
                    const isWeChat = /micromessenger/.test(userAgent);

                    if (isWeChat) {
                      alert('请在浏览器中打开页面重试\n点击右上角"···"选择"在默认浏览器中打开"');
                      return;
                    }

                    if (isIOS || isMac) {
                      window.open('https://apps.apple.com/app/betterus/id6447661126', '_blank');
                    } else {
                      window.open('https://h5.betterus.cc/download/betterus-latest.apk', '_blank');
                    }
                  }}
                >
                  下载APP
                </a>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-[#ECF0F1] hover:text-[#F1F600] focus:outline-none transition-colors duration-300"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 px-4 bg-[#2C3E50] border-t border-[#ECF0F1]/10">
            <button onClick={scrollToTop} className="block w-full text-left py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300">首页</button>
            <button onClick={scrollToProducts} className="block w-full text-left py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300">产品</button>
            <Link to="/coaches" className="block py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300">教练风采</Link>
            <Link to="/about" className="block py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300">关于我们</Link>
            <button
              onClick={() => {
                setIsOpen(false);
                setIsModalOpen(true);
              }}
              className="block w-full text-left py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300"
            >
              联系平台
            </button>
            <a
              href="https://h5.betterus.cc"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 text-[#ECF0F1] hover:text-[#F1F600] font-medium transition-colors duration-300 flex items-center"
              onClick={(e) => {
                e.preventDefault();
                const userAgent = navigator.userAgent.toLowerCase();
                const isIOS = /iphone|ipad|ipod/.test(userAgent);
                const isMac = /macintosh|mac os x/.test(userAgent) && !/mobile/.test(userAgent);
                const isWeChat = /micromessenger/.test(userAgent);

                if (isWeChat) {
                  alert('请在浏览器中打开页面重试\n点击右上角"···"选择"在默认浏览器中打开"');
                  return;
                }

                if (isIOS || isMac) {
                  window.open('https://apps.apple.com/app/betterus/id6447661126', '_blank');
                } else {
                  window.open('https://h5.betterus.cc/download/betterus-latest.apk', '_blank');
                }
              }}
            >
              <span>下载APP</span>
              <MaterialIcon icon="download" className="ml-1 text-sm" />
            </a>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar; 
